module.exports = __webpack_public_path__ + "static/media/round-work-outline-24-px.3ecc24e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-work-outline-24-px.svg
// module id = 767
// module chunks = 0